"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trades = exports.Trade = void 0;
class Trade {
    constructor(trade) {
        this.tradeId = 0;
        this.market = 'BTC-USDC';
        this.buyerUserId = 0;
        this.sellerUserId = 0;
        this.buyerOrderId = 0;
        this.sellerOrderId = 0;
        this.side = 'buy';
        this.type = 'limit';
        this.amount = 0;
        this.price = 0;
        this.buyerFee = 0;
        this.sellerFee = 0;
        this.date = new Date();
        if (!trade)
            return;
        this.tradeId = trade.tradeId || this.tradeId;
        this.market = trade.market || this.market;
        this.buyerUserId = trade.buyerUserId || this.buyerUserId;
        this.sellerUserId = trade.sellerUserId || this.sellerUserId;
        this.buyerOrderId = trade.buyerOrderId || this.buyerOrderId;
        this.sellerOrderId = trade.sellerOrderId || this.sellerOrderId;
        this.side = trade.side || this.side;
        this.type = trade.type || this.type;
        this.amount = trade.amount || this.amount;
        this.price = trade.price || this.price;
        this.buyerFee = trade.buyerFee || this.buyerFee;
        this.sellerFee = trade.sellerFee || this.sellerFee;
        this.date = trade.date || this.date;
    }
}
exports.Trade = Trade;
class Trades {
    constructor() {
        this.list = {};
    }
}
exports.Trades = Trades;
//# sourceMappingURL=trade.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exchange-common/models/trade.js
// module id = 203
// module chunks = 0